import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentorLogsFilterModel } from 'common/models/page-models/mentor-mapping/mentor-log-filter-data.model';
import { MentorLogsFilterMetaModel } from 'common/models/page-models/mentor-mapping/mentor-log-filter-form-meta.model';
import { MentorLogsListingModel } from 'common/models/page-models/mentor-mapping/mentor-logs-model';
import { MentorModel } from 'common/models/page-models/mentor/mentor-data-model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentorLogsWidgetService } from 'common/widget/mentor/mentor-logs-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class MentorLogsGridResolver extends GridResolver<MentorModel, MentorLogsListingModel> {
    constructor(
        protected fs: MentorLogsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties.recordPerPage;
        widget.searchableFeilds = metaModel.properties.searchableFields;
        transferData.filterData = new MentorLogsFilterModel();
        transferData.filterMeta = new MentorLogsFilterMetaModel().getMetaModel();
       // this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
}